import { render, staticRenderFns } from "./joinQueue.vue?vue&type=template&id=63733978&scoped=true&"
import script from "./joinQueue.vue?vue&type=script&lang=js&"
export * from "./joinQueue.vue?vue&type=script&lang=js&"
import style0 from "./joinQueue.vue?vue&type=style&index=0&id=63733978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63733978",
  null
  
)

export default component.exports